module.exports = __webpack_public_path__ + "static/far-traveler-mtg_clb-5a5e7f491bc1b7eeab13afc8b2c561da.jpg";